import { render, staticRenderFns } from "./Donation.vue?vue&type=template&id=21770265&scoped=true&"
import script from "./Donation.vue?vue&type=script&lang=js&"
export * from "./Donation.vue?vue&type=script&lang=js&"
import style0 from "./Donation.vue?vue&type=style&index=0&id=21770265&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21770265",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DonationForm: require('/home/bitrix/frontend/components/home/DonationForm.vue').default})
